<template>
    <v-form ref="form">
        <v-row class="mt-4">
            <v-col cols="6" class="py-0">
                <v-file-input
                    label="Planograma"
                    outlined
                    dense
                    v-model="value.planograma"
                    class="input-cinza"
                    prepend-icon=""
                    prepend-inner-icon="mdi-paperclip"
                    accept=".pdf,.png,.jpg,.jpeg"
                    truncate-length="30"
                ></v-file-input>
            </v-col>
            <v-col cols="12" class="">
                <v-textarea
                    outlined
                    v-model="value.comentario"
                    dense
                    rows="5"
                    label="Comentários Gerais"
                    class="input-cinza py-0"
                ></v-textarea>
            </v-col>
        </v-row>
        <div class="resumo">
            <div class="resumo-title">Resumo do acordo</div>
            <div class="resumo-conteudo">
                <div class="resumo-item">
                    <span class="titulo">Cadastro do Acordo:</span>
                    <p>
                        Período:
                        <strong>{{ periodoAcordos }}</strong>
                    </p>
                    <p>
                        Projeto: <strong>{{ value.projeto }}</strong>
                    </p>
                    <p>
                        Categoria: <strong>{{ categoriaNome }}</strong>
                    </p>
                    <p>
                        Espaço GC: <strong>{{ espacoGCNome }}</strong>
                    </p>
                </div>
                <v-divider />
                <div class="resumo-item">
                    <span class="titulo">Seleção de Filiais:</span>
                    <p>
                        Filiais:
                        <strong>{{ resumo.filiais || 0 }} selecionadas</strong>
                    </p>
                </div>
                <v-divider />
                <div class="resumo-item">
                    <span class="titulo">Seleção de Produtos:</span>
                    <p>
                        Produtos:
                        <strong>{{ resumo.produtos || 0 }} selecionados</strong>
                    </p>
                </div>
            </div>
        </div>

        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>
    </v-form>
</template>

<script>
export default {
    props: ["value"],
    inject: ["listaCampos"],
    async created() {
        var lista = await this.listaCampos;
        this.lista.espacoGC = lista.espacoGC || [];
        this.lista.categorias = lista.categorias || [];
    },
    data() {
        return {
            resumo: {},
            menuProps: {
                bottom: true,
                offsetY: true,
                contentClass: "select-outline",
                transition: "slide-y-transition",
            },
            lista: {
                espacoGC: [],
                categorias: [],
            },
            regra: {},
            semAcesso: false,
        };
    },
    computed: {
        periodoAcordos() {
            const meses = (this.value.periodo || []).map((m) => {
                return this.$moment(m, "YYYY-MM").format("MM/YYYY");
            });
            return `${meses.slice(0, 5).join(", ")} ${meses.length > 5 ? "..." : ""}`;
        },
        categoriaNome() {
            return (this.value.categorias || []).join(", ");
        },
        espacoGCNome() {
            if (!this.value.id_espaco_gc || !this.lista.espacoGC) return "";
            const e = this.lista.espacoGC.find(
                (e) => e.value === this.value.id_espaco_gc
            );
            return e ? e.text : "";
        },
    },
    methods: {
        setResumo(resumo) {
            this.resumo = resumo;
        },
        validate() {
            return this.$refs.form.validate();
        },
        resetValidation() {
            this.resumo = {};
            try {
                this.$refs.form.resetValidation();
            } catch (error) {
                //console.log(error)
            }
        },
    },
};
</script>

<style lang="scss">
.resumo {
    .resumo-total {
        grid-column: span 6;
        text-align: center;
        font-size: 1rem;
        margin-top: 1rem;
    }
    .resumo-title {
        font-size: 1.1rem;
        background: var(--v-primary-base);
        text-align: center;
        padding: 10px;
        color: #fff;
        font-weight: 500;
        border-radius: 8px 8px 0 0;
    }
    .resumo-conteudo {
        display: grid;
        grid-template-columns: 1fr 20px 1fr 20px 1fr;
        grid-gap: 15px;
        align-items: center;
        padding: 20px;
        border-radius: 0 0 8px 8px;
        font-weight: 500;
        font-size: 0.8rem !important;
        color: #808080;
        border: 1px solid #ddd;
        p {
            margin: 0;
        }
        .resumo-item {
            width: 100%;
            height: 100%;
            padding: 10px 20px;
            border-radius: 8px;
            background: #eaeaea;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .titulo {
                font-weight: bold;
                color: var(--v-primary-base);
            }
        }
    }
}
</style>
